import { Link } from "react-router"
import type { Locale } from "../../content/types"
import { getPagePath } from "../../content/registry"
import { ui } from "../../content/ui"

interface NotFoundPageProps {
  locale: Locale
}

/** Rendered client-side for unknown in-app paths; direct document requests get nginx's 404.html. */
export default function NotFoundPage({ locale }: NotFoundPageProps) {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4 py-24">
      <p className="text-7xl font-bold text-button-primary mb-4">404</p>
      <h1 className="text-3xl md:text-4xl font-bold text-text-primary mb-4">{ui.notFound.title[locale]}</h1>
      <p className="text-lg text-text-secondary max-w-xl mb-8">{ui.notFound.body[locale]}</p>
      <div className="flex flex-wrap justify-center gap-4">
        <Link
          to={getPagePath("home", locale)!}
          className="inline-block bg-button-primary hover:bg-[#c55b01] text-white px-8 py-4 rounded-pill font-semibold transition-all duration-300"
        >
          {ui.notFound.goHome[locale]}
        </Link>
        <Link
          to={getPagePath("services", locale)!}
          className="inline-block bg-button-secondary hover:bg-button-secondary-hover text-text-primary px-8 py-4 rounded-pill font-semibold transition-all duration-300"
        >
          {ui.nav.services[locale]}
        </Link>
      </div>
    </div>
  )
}
